var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _GameplanGroup = _interopRequireDefault(require("./GameplanGroup"));

var _Basic = require("../../../elements/Basic");

var _withDataRefresh = _interopRequireDefault(require("../../../hoc/withDataRefresh"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Gameplan/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Gameplan = function (_React$Component) {
  (0, _inherits2.default)(Gameplan, _React$Component);

  var _super = _createSuper(Gameplan);

  function Gameplan(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Gameplan);
    _this = _super.call(this, props);

    _this.calculateRowLimitForGroup = function (groupSize) {
      var limit = _this.rowLimit;
      _this.rowLimit -= groupSize;
      return Math.max(limit, 0);
    };

    _this.rowLimit = props.rowLimit;
    return _this;
  }

  (0, _createClass2.default)(Gameplan, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          rowLimit = _this$props.rowLimit,
          matchGroups = _this$props.matchGroups,
          onPress = _this$props.onPress,
          refreshing = _this$props.refreshing,
          renderMatch = _this$props.renderMatch,
          onRefresh = _this$props.onRefresh,
          createHref = _this$props.createHref,
          headerStyle = _this$props.headerStyle,
          NavWrapper = _this$props.NavWrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["rowLimit", "matchGroups", "onPress", "refreshing", "renderMatch", "onRefresh", "createHref", "headerStyle", "NavWrapper"]);
      return _react.default.createElement(_Basic.ScrollView, (0, _extends2.default)({}, rest, {
        refreshControl: _react.default.createElement(_Basic.RefreshControl, {
          refreshing: refreshing,
          onRefresh: onRefresh,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 46,
            columnNumber: 33
          }
        }),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44,
          columnNumber: 13
        }
      }), matchGroups && matchGroups.length ? matchGroups.map(function (group, index) {
        var limit = rowLimit && _this2.calculateRowLimitForGroup(group.length);

        return typeof limit !== 'number' || limit > 0 ? _react.default.createElement(_GameplanGroup.default, {
          key: "gameplanGroup_" + (0, _get.default)(group, '[0].id'),
          rowLimit: limit,
          matches: group,
          onPress: onPress,
          renderMatch: renderMatch,
          createHref: createHref,
          headerStyle: headerStyle,
          NavWrapper: NavWrapper,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 52,
            columnNumber: 31
          }
        }) : null;
      }) : null);
    }
  }]);
  return Gameplan;
}(_react.default.Component);

Gameplan.propTypes = {
  matchGroups: _propTypes.default.instanceOf(Array).isRequired,
  onPress: _propTypes.default.func,
  refreshing: _propTypes.default.bool,
  onRefresh: _propTypes.default.func,
  createHref: _propTypes.default.func,
  NavWrapper: _propTypes.default.func
};

var _default = (0, _withDataRefresh.default)(Gameplan);

exports.default = _default;